import { fetchApi } from './api';

// Fetch all bookings
export const getBookings = async () => {
  return fetchApi('/bookings', { method: 'GET' });
};

// Fetch booking details
export const getBookingDetails = async (id) => {
  return fetchApi(`/bookings/${id}`, { method: 'GET' });
};

